export const InventoryFormOnCreate = Object.freeze({
	CreateNew: 1,
	MergeByPk: 2,
});
